var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrap"},[(_vm.options)?_c('highcharts',{attrs:{"options":_vm.options}}):_c('div',{staticClass:"text-muted small"},[_vm._v("Нет данных для графика")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }